import { AssignableRolesReply } from '../dtos/AssignableRolesReply';
import { AssignableRoles } from '../models/AssignableRoles';

export const transformAssignableRolesReply = (
  dto: AssignableRolesReply,
): AssignableRoles => {
  return dto.roles;
};
